import { BaseComponent } from '../core/BaseComponent.js';

/**
 * Same open/close behavior as RequestUploadModal (#request_upload_modal).
 */
export class ConfirmFacilityModal extends BaseComponent {
    constructor(selector = '#confirm_facility_modal', options = {}) {
        super(selector, options);
        this.closeButtonSelector = '.close_modal, .cancel_button';
    }

    init() {
        if (!super.init()) return this;
        this.bindEvents();
        return this;
    }

    bindEvents() {
        if (!this.element) return this;

        this.$$(this.closeButtonSelector).forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        });

        const overlay = this.element.querySelector('.overlay');
        if (overlay) {
            overlay.addEventListener('click', () => this.close());
        }

        return this;
    }

    open() {
        this.fadeIn(this.element);
    }

    close() {
        this.fadeOut(this.element);
    }

    fadeIn(el) {
        el.style.display = 'block';
        el.style.opacity = 0;
        el.style.transition = 'opacity 0.2s';

        requestAnimationFrame(() => {
            el.style.opacity = 1;
        });
    }

    fadeOut(el) {
        el.style.opacity = 0;
        el.style.transition = 'opacity 0.2s';

        setTimeout(() => {
            el.style.display = 'none';
        }, 200);
    }
}
